import script from "./DetailCensus.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailCensus.vue?vue&type=script&setup=true&lang=js"

import "./DetailCensus.vue?vue&type=style&index=0&id=3b87b178&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b87b178"]])

export default __exports__